<template>
  <div id="CreateReturnReviewAndSubmit" class="bg-light pb-5">
    <!-- Area Description -->
    <div class="row">
      <div class="col">
        <p class="pl-3 py-4">
          Verify the information below is accurate and click <strong>'Submit'</strong> when you are ready.
        </p>
      </div>
    </div>
    <!-- Return Summary -->
    <div class="row">
      <div class="col">
        <div class="mx-3 pb-2">
          <h2>RETURN INFORMATION</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="mx-3 pb-2"><strong>Dealer Return Reference:</strong> {{ returnDraftDto.ReferenceNumber }}</div>
      </div>
      <div class="col-4">
        <div class="mx-3 pb-2"><strong>Contact Name:</strong> {{ returnDraftDto.ContactName }}</div>
      </div>
      <div class="col-4">
        <div class="mx-3 pb-2">
          <strong>Prefered Contact Method:</strong> {{ returnDraftDto.PreferredContactMethod }}
        </div>
      </div>
      <div class="col-4">
        <div class="mx-3 pb-2">
          <strong>Return Method:</strong> {{ getEnumWithSpaces(returnDraftDto.ActionForNonReturnable) }}
        </div>
      </div>
      <div class="col-4">
        <div class="mx-3 pb-2"><strong>Contact Email:</strong> {{ returnDraftDto.ContactEmail }}</div>
      </div>
      <div class="col-4">
        <div class="mx-3 pb-2"><strong>Contact Phone:</strong> {{ returnDraftDto.ContactPhone }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="mx-3 pb-2">
          <h2>PARTS INFORMATION</h2>
        </div>
      </div>
    </div>
    <b-row>
      <b-col>
        <div class="mx-3 pb-2">
          <DnTable
            id="partResultsTable"
            ref="partResultsTableRef"
            hover
            striped
            :no-sort-reset="false"
            :items="returnDraftDto.Items"
            :fields="partResultsColumns"
            stacked="md"
            :no-provider-filtering="true"
            show-empty
            :no-local-sorting="true"
            class="blue mb-0"
          >
            <template #OemPartCode="{ row }">
              <PartDetailsLink :oem-part-code="row.item.OemPartCode" />
            </template>
            <template #UnitPrice="{ row }">
              <CurrencyText :amount="row.item.Price" class="pull-right" />
            </template>
            <template #Total="{ row }">
              <CurrencyText :amount="row.item.Total" class="pull-right" />
            </template>
          </DnTable>
          <div class="row no-gutters modify px-2 mb-5">
            <div class="col px-1">
              <strong>TOTAL</strong>
              <strong>
                <CurrencyText :amount="total" class="pull-right" />
              </strong>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CurrencyText from "@/components/Elements/CurrencyText";
import PartDetailsLink from "@/components/Elements/PartDetailsLink";
import { stringHelper } from "@/components/mixins/stringHelper";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
  components: {
    CurrencyText,
    PartDetailsLink,
    DnTable,
  },
  mixins: [stringHelper],
  props: {
    returnDraftDto: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    partResultsColumns: [
      { key: "OemPartCode", label: "Part Number", sortable: true },
      { key: "PartDescription", label: "Description", sortable: true },
      { key: "SalesOrganization", label: "Sales Org.", sortable: true },
      { key: "Quantity", label: "Qty", sortable: true },
      { key: "UnitPrice", label: "Unit Price", sortable: true },
      { key: "Total", label: "Total Price", sortable: true },
    ],
  }),
  computed: {
    total: function () {
      if (this.returnDraftDto === undefined) {
        return 0;
      }
      if (this.returnDraftDto.Items === undefined) {
        return 0;
      }
      return this.returnDraftDto.Items.reduce(function (a, c) {
        return a + Number(c.Total || 0);
      }, 0);
    },
  },
};
</script>
